<template>
<div class="chapter">
<div class="inner_page">
<div id="Chapter-One.html" xml:lang="en-US">
<div class="Basic-Text-Frame-12">
<p class="ch"><a id="Anchor-1"></a>One</p>
<p class="body-text-opening"><span class="lic" style="font-size:1.83em;" xml:lang="en-US">“Y</span>ou’ve decided to do <em class="italic">what?</em>”</p>
<p class="body-text">It was Friday afternoon, the end of a grueling workweek, and
					Ella McLeod desperately wanted to put up her swollen feet...and relax.</p>
<p class="body-text">Instead, from the depths of the sofa in her town house living
					room, Ella bit back the rest of the explosive reaction that threatened to erupt.
					She hoped wildly that her sister’s next words would settle her world back on its
					axis so that the nasty jolt of shock reverberating through her system might just
					evaporate.</p>
<p class="body-text">As if the sight of Ella’s swollen belly prodded her conscience,
					Keira’s gaze skittered away and she had the good grace to look discomforted.
					“Dmitri and I have decided to go to Africa for a year.”</p>
<p class="body-text">Ella shifted to ease the nagging ache in her lower back that
					had started earlier at the law chambers. Keeping her attention fixed on her
					sister fidgeting on the opposite end of the sofa, she said, “Yes, I understood
					that part—you and Dmitri plan to work for an international aid charity.”</p>
<p class="body-text">Her younger sister’s gaze crept back, already glimmering with
					relief. “Oh, Ella, I knew you’d understand! You always do.”</p>
<p class="body-text"><em class="italic">Not this time.</em> Clearly Keira
					thought this was a done deal. It was rapidly becoming clear why Keira had
					dropped in this evening. And Ella had thought her sister’s anticipation about
					the baby’s imminent arrival had driven the surprise visit....</p>
<p class="body-text">How wrong she’d been!</p>
<p class="body-text">Gathering herself, Ella said slowly, “I don’t quite understand
					the rest. What about the baby?”</p>
<p class="body-text">The baby.</p>
<p class="body-text">The baby in her belly that Keira had been so desperate for.
					Keira’s baby. A baby girl. Keira and Dmitri had been present at the twenty-week
					ultrasound when the baby’s sex had been revealed. Afterward the pair had gone
					shopping to finish buying furnishings for a nursery suitable for a baby
					girl.</p>
<p class="body-text">Yet now that very same baby girl suddenly appeared to have
					ceased to be the focus of her sister’s universe.</p>
<p class="body-text">“Well—” Keira wet her lips “—obviously the baby can’t come
					with.”</p>
<p class="body-text">It wasn’t obvious at all.</p>
<p class="body-text">“Why not?” Ella wasn’t letting Keira wriggle out of her
					responsibilities so easily. <em class="italic">Not this time.</em> This
					wasn’t the course of expensive French lessons Keira had grown tired of...or the
					fledgling florist business that Ella had sunk money into so that Keira would
					have a satisfying career when the one she’d chosen had become impossible. This
					was the <em class="italic">baby</em> Keira had always dreamed of one day
					having.</p>
<p class="body-text">When Keira bit her lip and tears welled up in her eyes, a
					familiar guilt consumed Ella. Before she could relent—as she always did—she
					said, “Keira, there’s no reason why the baby can’t go with you. I’m sure you’ll
					find people in Africa will have babies.”</p>
<p class="body-text">The tears swelled into big, shiny drops. “What if the baby
					becomes ill? Or dies? Ella, it’s not as if this is a five-star beach resort.
					This is aid work in a poverty-stricken part of Africa.”</p>
<p class="body-text">Refusing to be drawn into her sister’s dramatics, Ella leaned
					forward and tore a tissue from the box on the glass coffee table in front of the
					sofa, then passed it to Keira.</p>
<p class="body-text">“Do you even know what kind of infrastructure exists? You could
					ask whether a baby would be safe.” But Ella suspected she was fighting a losing
					battle when Keira failed to answer. She tried again. “If it’s so unsafe, then
					what about your own health? Your safety? Have you and Dmitri thought this
					through? Do you really want to be living in a war zone?”</p>
<p class="body-text">“It’s not a war zone,” Keira denied hotly. The tears had
					miraculously evaporated without a dab from the tissue that drifted to the
					carpet. “Credit me with some sense. It’s Malawi. The country is stable—the
					people are friendly. It’s poverty and illiteracy that we will be fighting.”</p>
<p class="body-text">So much for Keira’s claim that it would be impossible to take a
					child there. But Ella knew she’d lost the battle; Keira had already made up her
					mind—the baby was not going with her.</p>
<p class="body-text">“So what will happen to the baby?”</p>
<p class="body-text">Silence.</p>
<p class="body-text">Keira’s eyes turned pleading, just like those of Patches, the
					beloved spaniel from their childhood.</p>
<p class="body-text">“No! It is not staying with me.” Ella made it a statement. A
						<em class="italic">firm</em> statement. The kind she used when
					delivering an ultimatum to opposing counsel.</p>
<p class="body-text">Keira opened her mouth.</p>
<p class="body-text">The baby chose that moment to kick.</p>
<p class="body-text">Ella squeezed her eyes shut and suppressed a gasp at the hard
					jab against her ribs. Perspiration pricked at her forehead. She rubbed her
					side.</p>
<p class="body-text">Thrusting the pain away, she opened her eyes and said to her
					sister, “Have you spoken to Jo about your new plans?” Ella suspected Jo Wells,
					the social worker who had been involved in helping arrange the paperwork side of
					the adoption for Keira and Dmitri, would be as floored as she was by Keira’s
					change of heart.</p>
<p class="body-text">“Dmitri is right. We’re too young to become parents,” Keira
					said, sidestepping Ella’s question. “We haven’t even been married a year.”</p>
<p class="body-text">Drawing a deep breath, Ella said slowly, “A bit late to come to
					the conclusion that you’re not ready to be parents.”</p>
<p class="body-text">Nine months too late to be precise.</p>
<p class="body-text">Ella patted her own swollen stomach and watched mercilessly as
					Keira flushed.</p>
<p class="body-text">“This baby is due next week. All your life you wanted to get
					married, start a family...that’s why you did an early childcare course.” It was
					why Ella was now stuck across the sofa from her sister like a stranded whale
					with a bulging belly. “How can you walk away from your child now?”</p>
<p class="body-text">She had a nasty suspicion that she knew what—or rather, who—was
					behind the change of heart. Dmitri’s big brother. Yevgeny Volkovoy.</p>
<p class="body-text">Bossy big brother. Billionaire. Bigot.</p>
<p class="body-text">Ella couldn’t stand the man. He’d been furious to discover that
					Dmitri had gotten married without his say-so. He’d caused poor Keira endless
					tears with his terrifying tirades. Only by signing a post-nuptial agreement that
					allowed Keira the barest of maintenance in the case of divorce, and skewed
					everything in favor of the Volkovoy dynasty had Keira escaped his ire. Ella’d
					had a fit when she’d learned about the contract—and her alarm had grown when she
					read the terms. But by then it had been too late. The marriage was a done
					deal.</p>
<p class="body-text">And Keira hadn’t asked her for her expertise...or her help.</p>
<p class="body-text">Of course, Yevgeny hadn’t been in favor of the baby plan,
					either. Ella had known from the moment he’d switched to Russian. Dmitri had gone
					bright red—clearly he’d been less happy with Big Brother’s opinions.</p>
<p class="body-text">Now it sounded like Big Brother had finally gotten his way and
					managed to persuade Dmitri that he wasn’t ready to become a parent.</p>
<p class="body-text">Shifting again to ease her body’s increasing discomfort, Ella
					tried to stem the emotions that were swirling around inside her. Disbelief.
					Confusion. The beginnings of anger. None of this cocktail of emotions could be
					good for the baby. And, even though Ella had never had any intentions of having
					her own child, she’d taken great care of this one. She’d eaten well—going to
					great lengths to cut out her four-cups-a-day coffee habit—she’d even shortened
					her workday and made certain she’d been in bed by ten o’clock each night. She’d
					even taught herself to meditate so that the baby wouldn’t be contaminated by her
					stressful workday thoughts.</p>
<p class="body-text">All because she’d wanted to make sure the baby was perfect. Her
					gift to Keira.</p>
<p class="body-text">A gift Keira was now returning. Unborn, rather than
					unwrapped.</p>
<p class="body-text">How did one return a baby, for heaven’s sake? A baby that was a
					week away from becoming a live person?</p>
<p class="body-text">Which brought Ella to...</p>
<p class="body-text">“You’re not leaving for Africa before the baby is born.” She
					made it a statement. “There will be decisions that have to be made before you
					go.”</p>
<p class="body-text">Panic turned Keira’s eyes opaque. “No! I can’t.”</p>
<p class="body-text">“What do you mean you <em class="italic">can’t?</em>”</p>
<p class="body-text">“I can’t handle those decisions. We’ve already booked our
					tickets. You’ll need to make the arrangements.”</p>
<p class="body-text">“Me?” Drawing a deep shuddering breath, Ella went cold. “Keira,
					this is a baby we’re talking about—you can’t just walk away.”</p>
<p class="body-text">Her sister’s gaze dropped pointedly to Ella’s very round
					stomach. “You’re still the legal mother—the adoption doesn’t kick in until
					twelve days after the baby’s born. You know that, Ella. Because you told me so
					yourself.”</p>
<p class="body-text">Of course she knew it. Knowing stuff like that was part of her
					job as one of the most respected family lawyers in Auckland. But the knowledge
					was only just starting to sink in that Keira was planning to leave her holding
					the baby!</p>
<p class="body-text">“Oh, no!” Shaking her head, Ella said emphatically, “The only
					reason I lent you my body was so that you could have the baby you always dreamed
					of having. This is <em class="italic">your</em> dream, Keira. Your baby.”
						<em class="italic">My nightmare.</em> Then, in case it hadn’t sunk in,
					she added pointedly, “Yours and Dmitri’s.”</p>
<p class="body-text">“It’s <em class="italic">your</em> egg.”</p>
<p class="body-text">“Only because you can’t—” Ella bit off the words she’d been
					about to utter.</p>
<p class="body-text">Too late.</p>
<p class="body-text">Keira had gone white.</p>
<p class="body-text">Driven by remorse, Ella propelled her colossal self from the
					sofa and reached for Keira. Her sister was as stiff as a wooden block in her
					arms. “I’m so sorry, sweetheart, I shouldn’t have said that.”</p>
<p class="body-text">“It’s the truth.” Keira’s voice was flat. “I don’t have eggs or
					a uterus—I can’t have children.”</p>
<p class="body-text">“So why—” Ella almost bit her tongue off. She tightened her
					hold around her sister.</p>
<p class="body-text">“Don’t worry, you can ask. No, I’ll ask for you. ‘Why are you
					doing this? Why are you going to Africa without the baby?’ That’s what you
					really want to know, isn’t it?”</p>
<p class="body-text">Ella inclined her head.</p>
<p class="body-text">“I’m not sure I can explain.” Keira shrugged out of her
					hold.</p>
<p class="body-text">Given no choice, Ella let her sister go.</p>
<p class="body-text">While Keira gathered her thoughts, Ella became aware of the
					stark silence that stretched to the breaking point between them across the
					length of the sofa. A silent divide. It might as well have been the blue-green
					of the Indian Ocean that stretched beyond Australia all the way to Africa that
					yawned between them...because her sister had already retreated mentally farther
					than the arm’s length that separated them.</p>
<p class="body-text">Then Keira started to speak. “This is something both Dmitri and
					I have to do.” The blank, flat stare she fixed on Ella was a little unnerving.
					“I have to find myself, Ella. Find out who I am. All my life I wanted to teach
					little children—and have my own houseful of kids at home.” Her eyes grew more
					bleak. “But things didn’t go according to plan.”</p>
<p class="body-text">“Keira—”</p>
<p class="body-text">“I loved my job at Little Ducks Center—”</p>
<p class="body-text">“Keira.” The pain in her sister’s voice was unbearable.
					“Don’t!”</p>
<p class="body-text">But Keira carried on as if she hadn’t heard. “I couldn’t work
					there after the car accident...after I found out the truth—that there never
					would be any babies.”</p>
<p class="body-text">“Oh, honey—”</p>
<p class="body-text">Keira ducked away from Ella’s enfolding arms.</p>
<p class="body-text">An unwelcome sense of rejection filled Ella. Followed by
					emptiness. Instantly she scolded herself for her selfishness. She shouldn’t feel
					hurt. Keira was suffering.</p>
<p class="body-text">Yet, despite all her empathy for her sister, the most important
					question still remained unanswered: What about the baby? <em class="italic">The baby I helped create to fulfill your dream?</em> “But Keira, you will
					have a baby now—and you have a husband who loves you.”</p>
<p class="body-text"><em class="italic">Wasn’t that enough?</em></p>
<p class="body-text">Eyes softening, Keira admitted, “Yes, I was very, very
					fortunate to find Dmitri.”</p>
<p class="body-text">Ella hadn’t been so sure of that in the beginning. In fact,
					she’d foreseen nothing but heartbreak ahead for her sister. The arrival of
					Yevgeny Volkovoy in Auckland had been big news. Not satisfied with inheriting
					millions from the hotel empire his father had built up, the Russian had expanded
					the dynasty by building up the best river cruise operation in Russia. In the
					past few years he’d expanded into ocean cruise liners. With the planned
					expansion of Auckland’s cruise ship terminal, it was not surprising to learn
					that Yevgeny intended to secure Auckland as a voyage destination. What had been
					surprising had been learning through the newspapers that the Russian had fallen
					in love with New Zealand—and planned to relocate himself permanently. He’d sent
					his brother to New Zealand to secure corporate offices and staff them for
					Volkovoy Cruising’s new base. At first Ella had been less than impressed with
					the younger Volkovoy. With all the Volkovoy money Dmitri threw around, Ella had
					considered him spoiled and irresponsible. Nothing fortunate in that. Yet there
					was no doubt that he loved her sister...and thankfully he’d lost that reckless
					edge that had worried Ella so much at first. But heading off to Africa without
					the baby was not the right thing for Keira.</p>
<p class="body-text">The baby...</p>
<p class="body-text">Ella’s hand crept to her stomach.</p>
<p class="body-text">Mindful of how much her sister hated it when she nagged, Ella
					tempered her outrage. “You can’t just leave a baby for a few months...or even a
					year...and hope it will be there when you get back.”</p>
<p class="body-text">“I know that, Ella.” Keira’s brows drew together. “Don’t try to
					put the guilts on me. I’m not ready for a baby—neither of us are.”</p>
<p class="body-text">Ignoring her sister’s unfair accusation, Ella tried to fathom
					out what Keira’s response meant. Did she intend to give the baby up for
					adoption? Shock chilled Ella. Had her sister thought this through? She would
					hate to see Keira suffer when it one day came home to her what she’d lost.
					Perhaps Keira needed to be reminded of that.</p>
<p class="body-text">“If you’re thinking about giving the baby up for adoption, just
					remember it’s not going to be easy to find a surrogate again if you decide you
					want a baby when you come back from Africa.”</p>
<p class="body-text">She certainly wouldn’t be doing it again. She shouldn’t even
					have done it this time. Dumb. Dumb. Dumb decision. That’s what came of making
					decisions with her heart rather than her head.</p>
<p class="body-text">Keira flicked back her pale silver hair. “We can do what
					Yevgeny suggested when we first talked about you being our surrogate—put our
					names down to adopt a baby.”</p>
<p class="body-text">She’d known Dmitri’s high-handed brother was behind this!</p>
<p class="body-text">The ache in her lower back that had been worsening all day,
					intensified. It wasn’t worth arguing with Keira, pointing out that putting down
					your name didn’t guarantee a baby because so few became available for adoption.
					And when one did, the legal mother had the final say. She alone could choose
					whichever couple she wanted—there was no waiting list, no way to predict who she
					would choose.</p>
<p class="body-text">But right now Keira’s future plans were not her concern.</p>
<p class="body-text">“And what about this baby?” Ella knew she sounded angry. But,
					damn it, she <em class="italic">was</em> angry. Yevgeny made her blood
					bubble—even when he wasn’t present. Just the mention of the man was enough! “You
					can’t just dump it—”</p>
<p class="body-text">“I’m not dumping it— You’re the legal mother. I know you’ll
					make the best decision for the baby.” There was an imploring expression in her
					sister’s eyes that caused the hairs at the back of Ella’s neck to stand on
					end.</p>
<p class="body-text">Oh, no! Keira <em class="italic">had</em> planned to leave
					the baby with her and come back to claim it. Panic prickled through her. “I
						<em class="italic">can’t</em> keep the baby.”</p>
<p class="body-text">Keira’s eyes teared up again. “I know I shouldn’t have expected
					you to. But you always wanted the adoption of the baby to us to be an open one.
					So I hoped you would consider...”</p>
<p class="body-text">“No!” Panic swamped Ella. “We have a surrogacy
					arrangement—”</p>
<p class="body-text">Keira was shaking her head. “But Ella, you explained we can’t
					actually adopt the baby until after you sign the consent to give her up on the
					twelfth day. As the legal mother, you’re entitled to change your mind—but so are
					we.”</p>
<p class="body-text">She’d explained the legalities too well to her sister. Ella
					swallowed a curse. “You can’t change your mind—because I can’t keep this
					baby.”</p>
<p class="body-text">A wave of sick helplessness engulfed her.</p>
<p class="body-text">Keira sighed. “We already have. We’re not ready to raise a
					child. I don’t even want to think about the decision you’re going to have to
					make, but you have to do what you feel is right, Ella. It’s your body, your
					b—”</p>
<p class="body-text">“Don’t tell me it’s my baby!”</p>
<p class="body-text">Keira looked doleful. “I think I always knew deep in my heart
					that you wouldn’t agree to keep her, and I’ve made peace with that. Even though
					I had so hoped...” Her little sister’s voice trailed away.</p>
<p class="body-text">Dear God.</p>
<p class="body-text">Did Keira not know how much this <em class="italic">hurt?</em> What she was <br/>asking? The pain that pierced her chest was
					sharp and unforgiving. And guilt made it worse. Ella wished she could burst into
					tears...weep and wail. But she couldn’t. Instead, she fought for composure.</p>
<p class="body-text">She’d always been the adult in their relationship. No doubt
					Keira had known all along she would agree to sort everything out.</p>
<p class="body-text">Her heart was racing, and her head had started to pound. The
					ache in her back seemed to be growing worse by the minute. Ella knew all this
					couldn’t be good for the baby. She had to calm down. <em class="italic">Think
						of the baby.</em> She drew a shuddering breath...counted to five...and
					exhaled slowly.</p>
<p class="body-text">Pulling a cloak of assumed indifference around herself, Ella
					said with every bit of dignity she could muster, “I have a job—a demanding job.
					I don’t have time for a pet, much less a baby.” Ella would’ve loved a pet—a cat.
					But she didn’t have time to care for any living thing.</p>
<p class="body-text">Keira was staring at her again, her bottom lip quivering.</p>
<p class="body-text">Ella refused to feel one bit guilty. She was <em class="italic">not</em> going to be left holding the baby; she couldn’t
					keep it. That had never been the plan. The baby had been conceived for Keira—and
					Dmitri—to parent. This was not her baby.</p>
<p class="body-text">Lifting her hand from her belly, she said, “Then we’re in
					agreement. I have no choice but to give your baby up for adoption.”</p>
<p class="body-text">“If you see no other way out.”</p>
<p class="body-text">Before she could reiterate that this was not her preference,
					that the baby was Keira and Dmitri’s responsibility, to her horror Ella felt the
					warm, wet flood as her water broke.</p>
<p class="body-text">Keira’s baby girl was not going to wait another week to be
					born.</p>
<p class="tb">* * *</p>
<p class="body-text-no-tab">Night had already fallen by the time Yevgeny Volkovoy
					strode into the waiting room set aside for family visitors on the hospital’s
					first floor. He didn’t notice the calming decor in gentle blues and creams lit
					up by strategically placed wall sconces, or even the soft-focus photographs of
					Madonna-like mothers cradling babies that hung on the wall. Instead, his focus
					homed in on where his brother sprawled across an overstuffed chair while
					watching a wide-screen television.</p>
<p class="body-text">Fixing startlingly light blue eyes on Dmitri, he demanded,
					“Where is he?”</p>
<p class="body-text">“Who?” Dmitri swung a blank look up at him.</p>
<p class="body-text">“The child.”</p>
<p class="body-text">“It’s not a boy...it’s a girl,” his brother corrected him even
					as the soccer game on the television recaptured his attention. “I told you that
					after the ultrasound.”</p>
<p class="body-text">Yevgeny suppressed the surge of bitter disappointment. He’d
					been so sure that the ultrasound had been read wrong. He should’ve known! For
					almost a century his family had produced boys...there hadn’t been a girl in
					sight. How typical of Ella McLeod to give birth to a girl. Contrary
					creature.</p>
<p class="body-text">He waved a dismissive hand. “Whatever. I want to see her.”</p>
<p class="body-text">Retracing his steps out of the family room he emerged in time
					to see his sister-in-law appear through the next door down the carpeted
					corridor. Yevgeny strode forward. Nodding at his startled sister-in-law as he
					passed her, he entered the private ward beyond.</p>
<p class="body-text">Keira’s icicle sister was sitting up in the bed, propped up
					against large cushions.</p>
<p class="body-text">Yevgeny came to an abrupt stop. He had never seen Ella McLeod
					in bed before.</p>
<p class="body-text">The sight caused a shock of discomfort to course through him.
					Despite the fact that she barely reached his shoulder when she was on her feet,
					she’d always seemed so formidable. Stern. Businesslike. Unsmiling. Even at
					family occasions she dressed in a sharp, formal fashion. Dark colors—mostly
					black dresses with neck scarves in muted shades.</p>
<p class="body-text">Now he allowed his gaze to drift over her and take in the other
					differences.</p>
<p class="body-text">No scarf. No oversize glasses. No makeup. Some sort of ivory
					frilly lace spilled around the top of her breasts. She looked
					younger...paler...more fragile than he’d ever seen her.</p>
<p class="body-text">The icicle must be thawing.</p>
<p class="body-text">Yevgeny shook off the absurd notion.</p>
<p class="body-text">As though sensing his presence, she glanced up from the screen
					of a slim white phone she’d been squinting at. Antagonism snaked down his spine
					as their eyes clashed.</p>
<p class="body-text">“What are you doing here?” she demanded.</p>
<p class="body-text">“Where is the baby?”</p>
<p class="body-text">He’d expected to find the child in her arms.</p>
<p class="body-text">He should’ve known better. There wasn’t a maternal bone in Ella
					McLeod’s frozen body. No softness. No tender feelings. Only sharp, legal-eagle
					eyes that she usually disguised with a pair of glasses—and from all accounts, a
					steel-trap brain. According to the rumor mill her law practice did very well. No
					doubt her success came from divorce dollars siphoned off men with avaricious
					ex-wives.</p>
<p class="body-text">Ella hadn’t answered. A haunted flicker in her eye captured his
					attention, but then the fleeting expression vanished and her focus shifted
					beyond him. Wheeling about, Yevgeny spotted the crib.</p>
<p class="body-text">Two strides and he stood beside it. The baby lay inside, snugly
					swaddled and fast asleep. One tiny hand curled beside her cheek, the fingers
					perfectly formed. Her lashes were impossibly long, forming dark curves against
					plump cheeks. Yevgeny’s heart contracted and an unexpected, fierce rush of
					emotion swept him.</p>
<p class="body-text">It took only an instant for him to fall deeply, utterly
					irrevocably in love.</p>
<p class="body-text">“She’s perfect,” he breathed, his gaze taking in every last
					detail. The thatch of dark hair—the Volkovoy genes. The red bow of her pursed
					mouth.</p>
<p class="body-text">A smile tilted the corners of his mouth up.</p>
<p class="body-text">Reaching out, he gently touched the curve where chin became
					cheek with his index finger.</p>
<p class="body-text">“Don’t wake her!”</p>
<p class="body-text">The strident demand broke the mood. Turning his head, Yevgeny
					narrowed his gaze and pinned the woman in the bed.</p>
<p class="body-text">“I had no intention of waking her,” he said softly, careful not
					to disturb the infant.</p>
<p class="body-text">“It’s only a matter of time before she wakens with you hovering
					over her like that.”</p>
<p class="body-text">“I never hover.” But he moved away from the cot—and closer to
					the bed.</p>
<p class="body-text">Ella didn’t respond. But he’d seen that look in her eyes
					before. She wasn’t bothering to argue...not because she’d been swayed by his
					denial, but because she was so damn certain of the rightness of her own
					opinion.</p>
<p class="body-text">The woman was a pain in the ass.</p>
<p class="body-text">The polar opposite of her sister, she was the least motherly
					woman he’d ever encountered—with the single exception of his own mother.</p>
<p class="body-text">Maybe it was as well she wasn’t cradling the baby; she’d freeze
					the little bundle if she got close enough. Ella was ice to the core—he’d been
					mistaken to imagine a thaw.</p>
<p class="body-text">“Dmitri called to tell me you’re planning to give up the child
					for adoption?” No discussion. No consultation. She’d made a life-changing
					decision that affected all of them, by herself. It was typical of the woman’s
					arrogant selfishness.</p>
<p class="body-text">“Then you must’ve heard that your brother and my sister have
					decided not to adopt the baby.”</p>
<p class="body-text">Was that irony buried in her voice? He couldn’t read her
					expression. “Yes—Dmitri told me at the office.”</p>
<p class="body-text">“At the same time that Keira was visiting me.”</p>
<p class="body-text">This time he definitely detected an edge. But he was less
					concerned about her annoyance than discovering the fate of the oblivious newborn
					in the cot. “So it’s true? You intend to give up the baby just like that?”</p>
<p class="body-text">Her chin shot up three notches at the snapping sound his
					fingers made. “I will take care of the arrangements to find a new set of parents
					as soon as I can.” Ella glanced down at the phone in her lap, then back at
					Yevgeny. “I’ve already left a message for the social worker who’s handling the
					adoption proceedings for Keira and Dmitri, notifying her of their change of mind
					and requesting that she get in touch with me ASAP.”</p>
<p class="body-text">“Of course you have.” It certainly hadn’t taken her long to
					start the process to get rid of the baby. Anger sizzled inside him. “You never
					considered keeping her?” Not that he’d ever allow the child to stay in her
					care.</p>
<p class="body-text">She shook her head, and the hair shrouding her face shimmered
					like the moonlit wisps of cloud outside the window. “Not an option.”</p>
<p class="body-text">“Of course it isn’t.”</p>
<p class="body-text">She stared back at him, managing to look haughty and removed in
					the hospital bed. So certain of the rightness of her stance. “Identifying
					suitable adoptive parents from Jo Wells’s records is the only feasible
					option.”</p>
<p class="body-text">“‘Feasible option?’” Was this how his own mother had reasoned
					when she’d divorced his father and lied her way into sole custody, only to turn
					around and abandon the same sons she’d fought so hard to keep from their father?
					“This is a baby we’re talking about—you’re not at work now.”</p>
<p class="body-text">“I’m well aware of that. And my main concern now is the best
					interests of the child—exactly as it would be if I was at work.”</p>
<p class="body-text">Yevgeny snorted. “You’re a divorce lawyer—”</p>
<p class="body-text">“A family lawyer,” she corrected him. “Marriage dissolution is
					only a part of my practice. Looking after the best interests of the children
					and—”</p>
<p class="body-text">“Whatever.” He waved an impatient hand. “I’d hoped for a little
					less <em class="italic">business</em> and a little more emotion right
					now.”</p>
<p class="body-text">From the lofty position of the hospital bed she raised an
					eyebrow in a way that instantly rankled. “You don’t transfer skills learned from
					business to your home life?”</p>
<p class="body-text">“I show a little more compassion when I make decisions that
					relate to the well-being of my family.”</p>
<p class="body-text">She laughed—a disbelieving sound. Yevgeny gritted his teeth and
					refused to respond. Okay, so he had a reputation—<br/>well-deserved, he
					conceded silently—for being ruthless in business. But that was irrelevant in
					this context. He’d always been fiercely protective of those closest to him. His
					brother. His father. His <em class="italic">babushka.</em></p>
<p class="body-text">He studied Ella’s face. The straight nose, the lack of
					amusement in her light brown eyes—despite her laughing mouth. No, he wasn’t
					going to reach her—he doubted she had any warmth to which he could appeal.</p>
<p class="body-text">Giving a sharp, impatient sigh, he said, “You’ve got blinkered
					vision. You haven’t considered all the <em class="italic">feasible</em>
					options.”</p>
<p class="body-text">For the first time emotion cracked the ice. “I can’t keep the
					baby!”</p>
<p class="Basic-Paragraph-8"></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter_One.vue?13f85f0a